import { createColumnHelper } from "@tanstack/react-table";
import { truncateText } from "helpers";
import { ProductCell, ProductsListItem } from "modules/products";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import styles from "../styles/TableStyles.module.scss";

const columnHelper = createColumnHelper<ProductsListItem>();

const useProductsColumns = (showSharedColumns = false) => {
  const { t } = useTranslation();

  const columns = useMemo(
    () => [
      columnHelper.accessor((row) => row.id, {
        id: "id",
        header: "#",
        enableSorting: false,
        size: 0.5,
        minSize: 0.5,
        cell: (cell) => (
          <p className={styles["statistics__table--index"]}>
            {cell.row.index + 1}
          </p>
        )
      }),
      columnHelper.accessor((row) => row.name, {
        id: "product",
        header: t("Product"),
        enableSorting: false,
        size: 15,
        minSize: 15,
        cell: (cell) => (
          <ProductCell
            image={cell.row.original.image}
            visibility={cell.row.original.visibility}
            name={truncateText(cell.getValue(), 30)}
            subtitle={cell.row.original.categoryName}
          />
        )
      }),
      ...(!showSharedColumns
        ? [
            columnHelper.accessor((row) => row.productsSold, {
              id: "productsSold",
              header: t("Products Sold"),
              enableSorting: false,
              size: 2,
              minSize: 2,
              cell: (cell) => (
                <p style={{ textAlign: "right" }}>
                  {cell.getValue()?.toLocaleString("en-US")}
                </p>
              )
            })
          ]
        : [
            columnHelper.accessor(
              (row) =>
                row.sharingsCount?.socialMedia.reduce(
                  (acc, curr) => acc + curr.count,
                  0
                ),
              {
                id: "sharingsCount",
                header: t("Sharings Count"),
                enableSorting: false,
                size: 2,
                minSize: 2,
                cell: (cell) => (
                  <p style={{ textAlign: "right" }}>
                    {cell.getValue()?.toLocaleString("en-US")}
                  </p>
                )
              }
            )
          ])
    ],
    [showSharedColumns, t]
  );

  return { columns };
};

export default useProductsColumns;
